import { Alert, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

interface NoPaymentMethodAlertProps {
  isOrganizationAdmin: boolean;
  isDrawer?: boolean;
}

const NoPaymentMethodAlert: React.FC<NoPaymentMethodAlertProps> = ({ isOrganizationAdmin, isDrawer }) => {
  return (
    <Alert
      icon={<WarningIcon sx={{ fontSize: 14 }} />}
      sx={{
        backgroundColor: '#ffeedf',
        color: '#7b3f07',
        borderRadius: 2,
        paddingY: 0,
        paddingLeft: 1,
        paddingRight: 1.5,
        lineHeight: 1.2,
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        '& .MuiAlert-icon': {
          color: '#7A4B1D',
          marginBottom: 2,
          marginRight: 1,
        },
        '& .MuiAlert-message': {
          display: 'flex',
          alignItems: 'center',
        },
      }}
    >
      {isOrganizationAdmin ? (
        <Typography sx={{ fontSize: 11, fontWeight: 500 }}>Please provide a valid payment method to submit your order</Typography>
      ) : (
        <Typography sx={{ fontSize: isDrawer ? 10 : 11, fontWeight: 500 }}>
          A valid payment method needs to be provided to submit your order. {!isDrawer && <br />} Please contact your
          organization's Admin.
        </Typography>
      )}
    </Alert>
  );
};

export default NoPaymentMethodAlert;
